// Set by CourtesyNavigationHeader (customer-experience) to the header's live rendered
// height; consumed by UnifiedHeader, UnifiedSideNav, and MainContainer so layout offsets
// can never drift out of sync with a hardcoded magic number.
export const HEADER_HEIGHT_CSS_VAR = "--shi-header-height";

export const GlobalConstants = {
    dateDisplayOptions: {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
    },
    dateFormat: "MM/dd/yyyy",
    moduleName: {
        customerSuccess: "Customer Success",
        customerExperience: "Customer Experience",
    },
    storageAccountUrls: {
        blueprints: {
            production:
                "https://shionestorage.blob.core.windows.net/shi-one-blueprints/shi_one_manifest.json",
            integration:
                "https://shionestorage.blob.core.windows.net/shi-one-blueprints-int/shi_one_manifest.json",
        },
        labsDocuments: {
            learnMore:
                "https://app.vidcast.io/share/5b09dee7-a139-4b68-a613-e7cca1bf8ef3?playerMode=vidcast",
        },
        filePond: {
            successPlanDocumentsContainer: "shione-success-plans-attachments",
        },
        images: {
            shiOneLogo:
                "https://shionestorage.blob.core.windows.net/shione/SHI_ONE_LOGO.png",
            shiOneRebrand:
                "https://shionestorage.blob.core.windows.net/shione/shi-logo-rebrand.png",
            shiOneRebrandSquare:
                "https://shionestorage.blob.core.windows.net/shione/shi-logo-rebrand.png",
            shiOneRebrandFavicon:
                "https://shionestorage.blob.core.windows.net/shione/shi-favicon-rebrand.png",
            catalystLogo:
                "https://shionestorage.blob.core.windows.net/shione/Catalyst-Square.png",
        },
        demoImages: {
            vigilantCloud:
                "https://shionestorage.blob.core.windows.net/shione/demo-vigilant-cloud.png",
            multiCloud:
                "https://shionestorage.blob.core.windows.net/shione/demo-multi-cloud.jpeg",
            everything:
                "https://shionestorage.blob.core.windows.net/shione/Everything-Demo.jpg",
            assetManagement:
                "https://shionestorage.blob.core.windows.net/shione/Assets-Demo.jpg",
            cisco:
                "https://shionestorage.blob.core.windows.net/shione/ciscoDemoCard.png",
        },
    },
    shiUserEmailDomains: ["@shi.com", "@stratascale.com"],
    externalLinks: {
        shiOneOnboardingWizard:
            "https://docs.one.shi.com/internal/how-to-onboard-your-customer",
    },
};
